/**
 * @author vishwadeep.kapoor
 * @Date: 2018-12-11 11:07:08
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2018-12-11 11:07:44
 */
/*
 *
 * RedeemZsc constants
 *
 */

import { DEFAULT_PRODUCT_TYPES } from '../GiftCardsList/constants';

export const DEFAULT_ACTION = '/RedeemZsc/DEFAULT_ACTION';
export const DEFAULT_REDEEMGIFTCARD_PAYLOAD = {
  category_ids: '',
  client_ids: '',
  include: 'variations,variation_types',
  page: 1,
  payment_method: 'zaggle_card',
  per_page: 12,
  product_types: DEFAULT_PRODUCT_TYPES,
  vendor_ids: '',
};



// WEBPACK FOOTER //
// client/containers/RedeemZsc/constants.js